import "../10. Battle/Library/LibraryBoxBattle.scss";
import Control from "../1. Core/Control";
import NP, {ValueChangedEventArgs} from "../1. Core/NP";
import TopAppBar from "../1. Core/Controls/TopAppBar/TopAppBar";
import Delegate from "../1. Core/Delegate";
import {ServerAPI} from "../1. Core/ServerAPI";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import AthletesFilterPanel from "./AthletesFilterPanel";

import AthletesInfoPanel from "../10. Battle/Library/Panels/AthleteInfoPanel";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import {getWeightStringById} from "../10. Battle/Util";


import './AthletesList.scss';
import {IAthlete, PageMode, SportType} from "../10. Battle/types";
import AthletesRatingFilterPanel from "./AthletesRatingFilterPanel";
import AthletesList from "./AthletesList";


interface IAthleteListItem {
	Athlete: IAthlete,
	Image?: string,
	Name?: string,
	State?: string,
	WeightCat: string,
	Country: string;
	Value: number;
}

interface IAthleteFiltersSort {
	FilterText?: string,
	TournamentId?: string,
	StateId?: number,
	Sex?: number,
	WeightCategory?: number,
	SortField?: string,
	SortDirection?: number
	StartDate?: string
	EndDate?: string
}

export interface IAthleteWithStat extends IAthlete {
	Strikes: number;
	LandedStrikes: number;
}

export default class AthletesRatingList extends Control {

	private _Count: number;
	private _Offset: number;

	private _topAppBar: TopAppBar;
	private _FilterText: string;
	private EvShowPageModeClick: Delegate;
	private EvPageModeChanged: Delegate;
	private EvAthleteOpened: Delegate;
	private _Athletes: IAthleteListItem[];
	private _dataTable: DataTable;
	private _filtersPanel: AthletesRatingFilterPanel;
	private _infoPanel: AthletesInfoPanel;

	private _dataWithFiltersNode: HTMLElement;
	private _dashWithInfoNode: HTMLElement;


	private _AllCount: number;
	private _CurrentFilter: IAthleteFiltersSort;

	private _Mode: PageMode

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this.EvAthleteOpened = new Delegate();
		this.EvShowPageModeClick = new Delegate();
		this.EvPageModeChanged = new Delegate();
		this._FilterText = '';
		this._Mode = null;
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();
		this.addClass('athletes-list');
		this._Count = 100;
		this._Offset = 0;

		this._topAppBar = new TopAppBar({
			Class: 'athletes-list__top-app-bar top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: NP.RM.getString('MMARating'),
			ParentNode: this._root,
			EvSearch: (s: Control, e: ValueChangedEventArgs) =>
			{
				this._FilterText = e.Value;
				this._Offset = 0;
				this._AllCount = null;
				this._refreshList();
			},
			EvHideSearch: () =>
			{
				this._Offset = 0;
				this._AllCount = null;
				this._FilterText = null;
				this._refreshList();
			},
			ShowSearchButton: true,
			MainButton: {
				FontImage: NP.FontImages.menu,
				EvClick: () => this.EvShowPageModeClick.fire(this)
			},
			EvFocusSearch: () =>
			{
			}
		});


		this._topAppBar.addItem(new IconToggleButton({
			FontImage: NP.FontImages.tune,
			Value: 'Filters',
			EvClick: (btn: IconToggleButton) =>
			{
				btn.setData(!btn.getData())
				if (this._root.contains(this._dashWithInfoNode))
					this._infoPanel.setIsVisible(!this._infoPanel.getIsVisible());
				else
					this._filtersPanel.setIsVisible(!this._filtersPanel.getIsVisible());
			}
		}));

		this._topAppBar.addItem(new IconToggleButton({
			FontImage: NP.FontImages.download,
			Value: 'Excel',
			EvClick: () =>
			{
				NP.downloadFile(`/ui-api/mma/getExcelAthletesRating?filter=${encodeURIComponent(JSON.stringify(this.getCurrentFilter()))}`)
			}
		}));

		this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');

		this._dashWithInfoNode = NP.createNode(document.documentElement, 'athletes-list__dash-with-info-container dash-with-info-container');

		this._dataTable = new DataTable({
			ParentNode: this._dataWithFiltersNode,
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			ShowRowIndex: true,
			ImageWidth: 32,
			Columns: [{
				Content: NP.RM.getString('Name'),
				Width: '20%',
				PropertyContent: 'Name'
			}, {
				Content: NP.RM.getString('Country'),
				PropertyContent: 'Country',
				Width: '20%'
			}, {
				Content: NP.RM.getString('WeightCategory'),
				PropertyContent: 'WeightCat',
				Width: '20%'
			}, {
				Content: NP.RM.getString('Sex'),
				PropertyContent: 'Sex',
				Width: '20%'
			}, {
				Content: NP.RM.getString('RatingValue'),
				PropertyContent: 'Value',
				Width: '15%'
			}],
			ShowPaginator: true,
			EvSortClick: (s: DataTable, e: any) =>
			{
				e.CanceSort = true;

				switch (e.Column)
				{
					case 0:
						this._filtersPanel.setSortValues('Name', e.Direction);
						break;
					case 1:
						this._filtersPanel.setSortValues('Country', e.Direction);
						break;
					case 2:
						this._filtersPanel.setSortValues('Weight', e.Direction);
						break;
					case 3:
						this._filtersPanel.setSortValues('Sex', e.Direction);
						break;
					case 4:
						this._filtersPanel.setSortValues('Value', e.Direction);
						break;
				}

				this._Offset = 0;

				this._refreshList();
			},
			EvItemClick: (s: object, e: { Item: IAthleteListItem }) =>
			{
				this.EvAthleteOpened.fire(this, {Athlete: e.Item.Athlete})
			},
			EvPaginatorLeftClick: () =>
			{
				this._Offset -= this._Count;
				this._refreshList();
			},
			EvPaginatorRightClick: () =>
			{
				this._Offset += this._Count;
				this._refreshList();
			},
			EvSelectionChanged: () =>
			{
			},
			EvScrolled: (s: DataTable, e: any) => this._onScrolled(s, e)
		});

		this._filtersPanel = new AthletesRatingFilterPanel({
			ParentNode: this._dataWithFiltersNode,
			Width: 280,
			TType: this._Mode == PageMode.boxers ? SportType.Box : SportType.MMA,
			EvFilterSortChanged: (sender: AthletesFilterPanel, args: IAthleteFiltersSort) =>
			{
				this._Offset = 0;
				this._AllCount = null;
				this._CurrentFilter = args;
				this._refreshList();
			}
		});
	}

	_onScrolled(s: DataTable, e: any)
	{
		if (e.scroll > 0 && e.isSmall)
			this._topAppBar.addClass('top-app-bar--fixed-scrolled');
		else
			this._topAppBar.removeClass('top-app-bar--fixed-scrolled');
	}

	refresh()
	{

		this._refreshList();

		this._onScrolled(null, {
			scroll: 0,
			isSmall: this._dataTable.getIsSmall()
		});
	}

	getCurrentFilter()
	{
		return this._filtersPanel.getFilterData();
	}

	async _refreshList()
	{
		this._dataTable.setRows([]);

		let fs = this.getCurrentFilter();
		let payload = {
			FilterText: this._FilterText,
			Offset: this._Offset,
			Count: this._Count,
			SportType: SportType.MMA,
			...fs
		};

		this._dataTable.updateColumnCaption(4, this._filtersPanel.getValueColumnName());

		let response = await ServerAPI.callUiApi("/mma/rating", payload, 'POST') as { List: IAthleteWithStat[], AllCount: number };

		if (response)
		{
			if (!this._AllCount)
				this._AllCount = response.AllCount;

			this._Athletes = response.List.map(el =>
			{
				let name = el.LastName;
				if (!name)
					name = el.FirstName;
				else
					name = el.LastName + " " + el.FirstName;

				let countryName = el.CountryName || "";

				if (el.State)
				{
					if (countryName)
						countryName += "/";
					countryName += el.State;
				}

				return {
					Athlete: el,
					Name: name.trim(),
					State: el.State ? el.State : '',
					Image: AthletesList.getAthleteImage(el),
					WeightCat: getWeightStringById(el.WeightCategory),
					Value: (el as any)[fs.ShowValue],
					Country: countryName,
					Sex: el.Sex == 0 ? NP.RM.getString('FemaleGender') : NP.RM.getString('MaleGender')
				} as IAthleteListItem
			});

			this._dataTable.setShowPaginator(this._AllCount > this._Count);

			this._dataTable.getRightPagButton().setEnabled(this._Offset + this._Count < this._AllCount);
			this._dataTable.updatePagCaption(`${this._Offset + 1} - ${Math.min(this._Offset + this._Count, this._AllCount)} ${NP.RM.getString("of")} ${this._AllCount}`);
			this._dataTable.getLeftPagButton().setEnabled(this._Offset > 0);

			this._dataTable.setRows(this._Athletes);

			let filter = this.getCurrentFilter();
			if (filter)
				switch (filter.SortField)
				{
					case 'Name':
						this._dataTable.updateSortIndicator(0, filter.SortDirection);
						break;
					case 'Country':
						this._dataTable.updateSortIndicator(1, filter.SortDirection);
						break;
					case 'Weight':
						this._dataTable.updateSortIndicator(2, filter.SortDirection);
						break;
					case 'Sex':
						this._dataTable.updateSortIndicator(3, filter.SortDirection);
						break;
					case 'Value':
						this._dataTable.updateSortIndicator(4, filter.SortDirection);
						break;
				}
		}

	}

	_getContentHeight()
	{
		return this._Height - this._topAppBar.getOffsetHeight();
	}

	setHeight(value: number)
	{
		super.setHeight(value);
		let h = this._getContentHeight();
		this._dataTable.setHeight(h);
		this._filtersPanel.setHeight(h);
		if (this._infoPanel)
			this._infoPanel.setHeight(h);
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		this._dataTable.setWidth(value);
		if (this._dataTable.getIsSmall())
		{
			this._topAppBar.removeClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
		else
		{
			this._topAppBar.addClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
	}

	getTopAppBar()
	{
		return this._topAppBar;
	}

	getDataTable()
	{
		return this._dataTable;
	}
}
